import EventsAlert from './EventsAlert';

export default EventsAlert;
